<script>
import { mapActions } from 'vuex'

import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'

import {
  GridComponent,
  ToolboxComponent,
  TooltipComponent,
  LegendComponent,
  LegendScrollComponent,
  DataZoomComponent,
  DataZoomInsideComponent,
  DataZoomSliderComponent,
  DatasetComponent,
  VisualMapComponent,
} from 'echarts/components'
import MChart, { THEME_KEY } from 'vue-echarts'

use([
  GridComponent,
  ToolboxComponent,
  TooltipComponent,
  LegendComponent,
  LegendScrollComponent,
  DataZoomComponent,
  DataZoomInsideComponent,
  DataZoomSliderComponent,
  DatasetComponent,
  CanvasRenderer,
  VisualMapComponent,
])
export default {
  components: {
    MChart,
  },
  props: {
    playerId: {
      type: Number,
      default: () => null,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      options: {
        toolbox: {
          feature: {
            dataView: {
              show: true,
              readOnly: true,
              title: this.$t('charts.data_vis'),
              lang: [
                this.$t('charts.data'),
                this.$t('charts.close'),
                this.$t('charts.add'),
              ],
            },
            magicType: {
              show: false,
              type: ['line', 'bar'],
            },
            restore: {
              show: false,
            },
            saveAsImage: {
              show: true,
              title: this.$t('charts.save_img'),
              pixelRatio: 3,
              backgroundColor: '#ffffff',
            },
          },
        },

        legend: {
          data: ['Performance'],
          icon: 'roundRect',
          textStyle: {
            color: this.$style['graph-text-color'],
          },
        },

        tooltip: {
          trigger: 'axis',
        },
        xAxis: [
          {
            data: null, // $scope.homeawayx,
            splitLine: {
              show: true,
            },
          },
        ],
        yAxis: [
          {
            min: 0,
            max: 100,
            splitLine: {
              show: false,
            },
          },
        ],

        series: [
          {
            name: 'Performance',
            type: 'bar',
            data: null,
            markLine: {
              label: {
                show: false,
              },
              data: [
                [
                  {
                    symbol: 'circle',
                    x: '90%',
                    yAxis: null,
                  },
                  {
                    symbol: 'circle',
                    label: {
                      normal: {
                        position: 'right',
                        formatter: null,
                      },
                    },
                    x: '10%',
                    yAxis: null,
                  },
                ],
              ],
              lineStyle: {
                normal: {
                  color: '#d3dae6',
                },
              },
            },
          },
        ],
      },
    }
  },
  provide: {
    [THEME_KEY]: 'light',
  },
  async created() {
    this.getPlayerStatData({ id: this.playerId })
      .then((response) => {
        if (typeof response !== 'undefined') {
          this.setGraphData(response)

          this.isLoading = false
          this.$emit('loaded', true)
        }
      })
      .catch((error) => {
        console.error(error, 'Opponent Ranking Performance Data fetch failed')
      })
  },
  methods: {
    ...mapActions('players', ['getPlayerStatData']),
    setGraphData(data) {
      if (typeof data.home_away !== 'undefined') {
        const homeawayx = []
        const homeawayy = []

        Object.keys(data.home_away).forEach((key) => {
          // valori grafico risuktati match
          const value = data.home_away[key]
          if (key !== 'average') {
            homeawayx.push(key + ' (M:' + value.width + ')')
            homeawayy.push(value.height.toFixed(1))
          }
        })

        const average = data.home_away.average

        this.options.xAxis[0].data = homeawayx
        this.options.series[0].data = homeawayy

        this.options.series[0].markLine.data[0][0].yAxis = average
        this.options.series[0].markLine.data[0][1].label.normal.formatter = average.toFixed(
          1
        )
        this.options.series[0].markLine.data[0][1].yAxis = average
      }
    },
    onResize() {
      if (typeof this.$refs.chart !== 'undefined') this.$refs.chart.resize()
    },
  },
}
</script>

<template>
  <v-responsive
    v-if="playerId !== null && playerId"
    v-resize="onResize"
    aspect-ratio="4/3"
    :class="$style.responsive"
  >
    <MChart
      v-if="!isLoading"
      ref="chart"
      :class="$style.chart"
      :option="options"
    />
  </v-responsive>
</template>

<style lang="scss" module>
@import '@design';

:export {
  graph-text-color: $color-text;
}

.chart {
  margin: 0 auto;
}

.responsive {
  min-height: 15rem;
  overflow: visible;
}
</style>
